'use strict';

/**
 * Pict-Provider-LoopsAPI
 * ----------------------
 * Browser-side client for the four refinement loops around a vision (Design, Build, Deliver, Gather
 * Feedback), computed server-side at read time. One call per vision; the VisionLoops view renders it.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'LoopsAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderLoopsAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath) { let tmpPrefix = this.routePrefix; if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; } return tmpPrefix + pPath.replace(/^\//, ''); }

	loops(pIDVision)
	{
		return libFrameworkClient.getJSON(this.fable, this._url('Vision/' + encodeURIComponent(pIDVision) + '/Loops'))
			.catch(() => null);
	}
}

module.exports = PictProviderLoopsAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
